import axios from 'axios';
import store from '../../Store'
import {disableLoader, enableLoader} from "../loaders/loader";
import {networkError} from "../messages/success_message";
import {noInternet, serverError} from "../error";

function _success(success) {
  return {type: 'INITIATE_STRIPE_PAYMENT_SUCCESS', success}
}

function _error(error) {
  return {type: 'INITIATE_STRIPE_PAYMENT_ERROR', error}
}

export function resetInitiateStripePayment() {
  return dispatch => {
    dispatch({
      type: "RESET_INITIATE_STRIPE_PAYMENT"
    });
  }
}


export function initiateStripePayment(data, slug) {
  return dispatch => {
    store.dispatch(enableLoader())
    let config = {
      url: localStorage.getItem('base_url') + `/${slug}/payment`,
      method: "post",
      dataType: 'json',
      data: data,
      headers: {}
    };

    axios(config)

      .then(res => {
        store.dispatch(disableLoader())
        dispatch(_success(res));

      }).catch(error => {
      if (error.response) {
        if (error.response.status >= 500)
          store.dispatch(serverError())
        dispatch(_error(error));
      } else if (error.request) {
        store.dispatch(noInternet())
      }
      store.dispatch(disableLoader())
    });
  }
}

export default initiateStripePayment;
